import React from 'react';
import './Calendar.css';

const TimeSlot = ({ slot, onSelect, isSelected }) => {
  const isAvailable = slot.available;
  
  return (
    <button
      className={`time-slot ${isAvailable ? 'available' : 'unavailable'} ${isSelected ? 'selected' : ''}`}
      onClick={() => isAvailable && onSelect(slot)}
      disabled={!isAvailable}
    >
      {slot.startTime} - {slot.endTime}
    </button>
  );
};

export default TimeSlot;